import React from 'react';
import { Grid, Header, Image, Icon, Segment, Divider } from 'semantic-ui-react';
import logo from "../../images/logo/logo-full-black.png";

const styles = {
    mainText: {
        color: "#0a0f1f"
    },
    bottomMessageBold: {
        fontSize: "0.9rem",
        marginBottom: "0px",
        fontWeight: "bolder"
    },
    bottomMessage: {
        fontSize: "0.85rem"
    }
}


const RegistrationForm = ({ action, gotoLogin, email }) => (
    <Grid padded={true} verticalAlign="middle">
        <Grid.Column width={1} />
        <Grid.Column width={14}>
            <Image src={logo} size='medium' centered />
            <Header as='h2' textAlign='center'
                style={{
                    marginBottom: "2em",
                    marginTop: "1.5em"
                }}
            >
                {action}
            </Header>

            <Segment textAlign='center' basic style={{ backgroundColor: "#c5f1ed" }}>
                <Header as='h4' icon textAlign='center'>
                    <Icon name='mail' circular />
                    <Header.Content>Verify Your Email ID</Header.Content>
                </Header>
                <p style={styles.mainText}>The verification mail has been sent to the following address<br />{email}</p>
                <Header as='h5' style={{ marginBottom: "0px" }}>Check and confirm your email to Activate your account.</Header>
                <p style={styles.mainText}> If you don't see it, check your Promotion, Spam or Junk folder</p>
                <Divider />
                <p style={styles.bottomMessageBold}>Still couldn't find the email?</p>
                <p style={styles.bottomMessage}>Try searching email from no-reply@aspenify.com</p>
            </Segment>




            <div className="ui grid pad_lr_0">
                <div className="two column row">
                    <div className="left floated column">
                        <a className="item middle aligned cursor-pointer" onClick={gotoLogin} style={{ paddingTop: "7px" }} >Back to Login</a>
                    </div>
                </div>
            </div>

        </Grid.Column>
    </Grid>
);

export default RegistrationForm;